import AttendanceHistory from '../components/AttendanceHistory';
import GeoClockCard from '../components/GeoClockCard';
import { Card, CardContent } from '../components/ui/card';
import PageHeader from '../components/ui/PageHeader';
import { formatDate } from '@/lib/format';

export default function Attendance() {
  const today = formatDate(new Date().toISOString(), {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div className="space-y-6">
      <PageHeader title="Attendance" subtitle={today} />
      <Card>
        <CardContent className="p-4">
          <GeoClockCard showHistoryLink={false} />
        </CardContent>
      </Card>
      <AttendanceHistory />
    </div>
  );
}
